// extracted by mini-css-extract-plugin
module.exports = {"container":"FlexibleImage_container__3-P1_","image":"FlexibleImage_image__3lXqI"};